import React from 'react';
import { Navigate } from 'react-router-dom';

const CandidateProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("candidateToken");
  
  console.log("Checking Token for Profile:", token); // 👈 Ye console mein dikhega

  if (!token || token === "undefined" || token === null) {
    console.log("Token missing! Redirecting to home...");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default CandidateProtectedRoute;